import type { CreditBalanceTrial } from "@/server/types/subscription";
import TrialStrip from "./TrialStrip";

interface FreeStripProps {
  /** Trial node from the /credit-balance DTO. null/undefined = paid user → no strip. */
  trial: CreditBalanceTrial | null | undefined;
  /** enforced mirror from the DTO. */
  enforced: boolean | undefined;
  /** Opens the plans / checkout from the trial-ended prompt. */
  onSubscribe: () => void;
}

/**
 * Trial state strip shown beneath the paid-plan grid.
 *
 * There is no longer a perpetual "Free plan" floor: when there is no active
 * trial, the user just sees the paid plans, plus (only when the trial has
 * ended and enforcement is live) a "trial ended" prompt. All trial-state logic
 * — and the defensive handling of `trial: null` / an old BE that omits the
 * field — lives in TrialStrip.
 */
export default function FreeStrip({
  trial,
  enforced,
  onSubscribe,
}: FreeStripProps) {
  return (
    <TrialStrip trial={trial} enforced={enforced} onSubscribe={onSubscribe} />
  );
}
